<div class="location-panel">
    <!-- Readonly Mode -->
    <div *ngIf="!isEditMode" class="readonly-view">
        <div class="panel-content">
            <div class="box">
                <div class="title">
                    <h5>{{ 'FEATURES.LOCATION.NAME' | translate }}</h5>
                </div>
                <p>{{ editLocation?.name || '-' }}</p>
                <div *ngIf="isUnrestricted">
                    <div class="title">
                        <h5>{{ 'GENERAL.TENANT' | translate }}</h5>
                    </div>
                    <p>{{ editLocation?.tenantName || '-' }}</p>
                </div>
            </div>

            <div class="form-actions">
                <button type="button" (click)="enterEditMode()">
                    {{ 'BUTTONS.EDIT' | translate }}
                </button>
            </div>
        </div>
    </div>

    <!-- Edit Mode -->
    <div *ngIf="isEditMode" class="edit-view">
        <form [formGroup]="locationForm" (ngSubmit)="saveAndExitEdit()" autocomplete="off">
            <div class="panel-content" [class.loading]="loading">
                <app-form-section>
                    <app-form-row>
                        <app-form-group>
                            <label for="name">{{ 'FEATURES.LOCATION.NAME' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="name"
                                formControlName="name"
                                type="text"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.name"
                                languageKey="FEATURES.LOCATION.NAME"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row *ngIf="showTenantSelection()">
                        <app-form-group>
                            <label for="tenantId">{{ 'GENERAL.TENANT' | translate }}</label>
                            <app-dropdown
                                appInputValidator
                                [items]="tenants$ | async"
                                id="tenantId"
                                formControlName="tenantId"
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.tenantId"
                                languageKey="GENERAL.TENANT"
                            />
                        </app-form-group>
                    </app-form-row>
                </app-form-section>

                <div class="form-actions">
                    <button type="button" (click)="cancelEdit()">{{ 'BUTTONS.CANCEL' | translate }}</button>
                    <button type="submit" class="primary">{{ 'BUTTONS.SAVE' | translate }}</button>
                </div>
            </div>
        </form>
    </div>
</div>
